import React from 'react';
import { Box, Typography, useTheme, useMediaQuery } from '@mui/material';
import { motion } from 'framer-motion';
import Button from '../Button';
import heroImage from '../../Media/hero-section-pic.png';

const HeroSection = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const viewportConfig = { once: false, margin: "0px 0px -100px 0px" };

  return (
    <Box 
      component={motion.div}
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={viewportConfig}
      transition={{ duration: 0.8 }}
      sx={{ 
        height: { xs: '700px', md: '800px' },
        width: '100%',
        position: 'relative', 
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'center',
        px:{xs:2,sm:4,lg:0},
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundImage: `
            url(${heroImage})
          `,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          zIndex: 0,
          filter: 'blur(0px)',
          transform: 'scale(1.02)'
        },
      }}
    >
      <Box 
        component={motion.div}
        sx={{ 
          position: 'relative', 
          zIndex: 2, 
          width: '100%',
          maxWidth: '1200px',
          mx: 'auto',
          py: { xs: 6, md: 4 },
          px: 0,
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <Box sx={{ width: '100%', px: 0 }}> 
          <Typography
            component={motion.div}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={viewportConfig}
            transition={{ delay: 0.2 }}
            variant="h1"
            sx={{
              color: '#64B5F6',
              fontWeight: 'bold',
              mb: 3,
              fontSize: { xs: '2rem', sm: '2.5rem', md: '3.5rem' },
              lineHeight: 1.2,
              textAlign: { xs: 'center', md: 'left' }
            }}
          >
            Your Path Home Starts Here
          </Typography>
          <Typography
            component={motion.div}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={viewportConfig}
            transition={{ delay: 0.2 }}
            variant="h2"
            sx={{
              color: '#b9d3ff',
              fontWeight: 'bold',
              mb: 3,
              fontSize: { xs: '1.2rem', sm: '1.2rem', md: '1.5rem' },
              lineHeight: 1.2,
              textAlign: { xs: 'center', md: 'left' }
            }}
          >
            Consistent Service | Competitive rates | Trusted Results
          </Typography>

          <Typography
            component={motion.div}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={viewportConfig}
            transition={{ delay: 0.4 }}
            variant="h6"
            sx={{
              color: 'white',
              mb: 4,
              lineHeight: 1.6,
              fontSize: { xs: '1rem', md: '1.1rem' },
              maxWidth: '700px',
              whiteSpace: 'pre-line',
              textAlign: { xs: 'center', md: 'left' },
            }}
          >
            Offering world class customer service, the best mortgage rates for you,{'\n'}and personalized service for the biggest purchase of your life.
          </Typography>

          <Box 
            component={motion.div}
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={viewportConfig}
            transition={{ delay: 0.6 }}
            sx={{ 
              display: 'flex', 
              gap: 2,
              flexDirection: { xs: 'column', sm: 'row' },
              alignItems: { xs: 'stretch', sm: 'flex-start' },
              justifyContent: { xs: 'center', md: 'flex-start' },
              px:{xs:3,md:'0'}
            }}
          >
            <Button 
              component={motion.a}
              initial={{ scale: 0 }}
              whileInView={{ scale: 1 }}
              viewport={viewportConfig}
              transition={{ type: "spring" }}
              variant="dark" 
              fullWidth={isMobile}
              href="mailto:rahim@rahimvirani.ca"
              aria-label="Contact us for a mortgage rate quote"
              sx={{ textDecoration: 'none' }}
            >
              Get a rate Quote
            </Button>
            
            <Button 
              component={motion.a}
              initial={{ scale: 0 }}
              whileInView={{ scale: 1 }}
              viewport={viewportConfig}
              transition={{ type: "spring", delay: 0.1 }}
              variant="primary" 
              fullWidth={isMobile}
              href="https://velocity.newton.ca/sso/public.php?sc=4zh515s047gn"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Start your mortgage pre-approval process"
              sx={{ textDecoration: 'none' }}
            >
              Get pre-approved in 3 minutes
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default HeroSection;